const Cardsimple = ({
    style = null,
    header = null,
    footer = null,
    condensed = false,
    tools = false,
    children
}) => {
    const JSXtools = (tools) ? <div className="card-tools small"><button type="button" className="btn bg-info btn-xs" data-card-widget="collapse"><i className="fas fa-minus"></i></button></div> : ""
    const JSXstyle = (style != null) ? style : ""
    const JSXcondensed = (condensed) ? "p-0" : ""
    const JSXheader = (header) && <><div className="card-header ">{JSXtools}{header}</div></>
    const JSXfooter = (footer) && <div className="card-footer clearfix">{footer}</div>
    const JXSbody = (children) && (<div className={`card-body ${JSXcondensed}`}>{children}</div>)
    
    return (
        <div className={`card ${JSXstyle}`}>
            {JSXheader}
            {JXSbody}
            {JSXfooter}
        </div>
    )
}
export default Cardsimple